module.exports = __webpack_public_path__ + "static/media/carousel-5.3e714141.png";